import { Banner, Sizes } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { ResultType } from 'Types/common';

const MandatoryInfo = ({ daInfo }: { daInfo: ResultType }): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);

  return (
    <Banner
      id="mandatory-info"
      mode="warning"
      hasIcon
      layout="embed"
      label={t('Result.mandatory.info.title', { context: daInfo?.taxReturnType })}
      titleSize={Sizes.XS}
      size={Sizes.S}
    />
  );
};

export default MandatoryInfo;
